export const getXCSRFToken = (): string => {
  const metaTag = document.querySelector(
    'meta[name="csrf-token"]'
  ) as HTMLMetaElement;

  return metaTag.content;
};
